import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricClickShare extends MetricBase {
    constructor() {
        super({
            field: "metric_click_share",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.click_share.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.click_share.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.click_share.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricClickShare;
